import axios from "../http";

let module = "/exam";

function selectExam(data) {
    return axios.post(module+"/selectExam", data);
}

function addExam(data) {
    return axios.post(module+"/addExam", data);
}

function updateExam(data) {
    return axios.put(module, data);
}

function examName(data){
    return axios.get(module+"/examName/"+data);
}

function selectExamByClassId(data){
    return axios.get(module+"/examInfo/"+data.id);
}


export default {
    selectExam,
    addExam,
    updateExam,
    examName,
    selectExamByClassId,
}
